import React from 'react';
import CtaButton from "./CtaButton"

function AdvantagesSection() {
  // Data for the advantage cards, updated with the new color theme.
  const advantages = [
    {
      number: '01',
      text: (
        <>
          <span className="font-semibold text-cyan-500">14-day free trial</span> – easily evaluate the platform's full features
        </>
      ),
    },
    {
      number: '02',
      text: (
        <>
          The AI employee interacts <span className="font-semibold text-slate-800">like a real person</span>
        </>
      ),
    },
    {
      number: '03',
      text: (
        <>
          Integration available with <span className="font-semibold text-cyan-500">Avito, Telegram, Facebook Messenger, Instagram, WhatsApp,</span> web chatbots, and other services
        </>
      ),
    },
    {
      number: '04',
      text: (
        <>
          No Extra Charges: <span className="font-semibold text-slate-800">All options are included in every plan,</span> and you pay ONLY for the number of conversations
        </>
      ),
    },
    {
      number: '05',
      text: (
        <>
          <span className="font-semibold text-slate-800">Data Security:</span> Configured via personal dashboard, no social media access required
        </>
      ),
    },
    {
      number: '06',
      text: (
        <>
          <span className="font-semibold text-cyan-500">Easy enough</span> for even a child to use
        </>
      ),
    },
  ];

  return (
    <section className="bg-slate-50 py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-slate-800 tracking-tight">
            <span className="text-cyan-500">Advantages</span> of choosing <br /> our platform
          </h2>
        </div>

        {/* Advantages Grid */}
        <div className="mt-16 max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {advantages.map((advantage) => (
            <div
              key={advantage.number}
              className="bg-white rounded-xl shadow-lg border border-slate-100 p-6 flex items-start space-x-4 transition-all duration-300 hover:shadow-xl hover:border-blue-200"
            >
              <div className="flex-shrink-0">
                <div className="px-2 py-1 inline-block border-2 border-blue-400 rounded-md">
                  <span className="text-blue-500 font-bold">{advantage.number}</span>
                </div>
              </div>
              <p className="text-slate-600 leading-relaxed pt-1">{advantage.text}</p>
            </div>
          ))}
        </div>

       <div className="mt-16">
          <CtaButton
            buttonText="GO TO THE PLATFORM"
            subText="14-day free trial for every user"
          />
        </div>
      </div>
    </section>
  );
}

export default AdvantagesSection;

